import { useRef } from 'react'

/**
 * Fenêtre modale générique.
 * Fermeture uniquement si le clic gauche commence ET se termine sur le fond
 * (évite la fermeture lors d'un drag depuis l'intérieur de la modale).
 */
export default function Modal({ open, onClose, title, children, maxWidth = 'max-w-lg' }) {
  const mouseDownOnBackdrop = useRef(false)

  if (!open) return null
  return (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
      onMouseDown={e => { mouseDownOnBackdrop.current = e.target === e.currentTarget }}
      onMouseUp={e => { if (mouseDownOnBackdrop.current && e.target === e.currentTarget) onClose() }}
    >
      <div
        className={`bg-gray-800 border border-white/10 rounded-2xl shadow-2xl w-full ${maxWidth} max-h-[90vh] overflow-y-auto`}
        onMouseDown={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-6 border-b border-white/10">
          <h2 className="text-xl font-semibold text-white">{title}</h2>
          <button
            onClick={onClose}
            className="text-white/40 hover:text-white text-2xl leading-none transition"
          >
            ×
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  )
}
